import { Component, Prop, getAssetPath, h } from '@stencil/core';

import { LandingStep } from '../../../interfaces/interface.landing';

@Component({
  tag: 'landing-step-by-step',
  styleUrl: 'landing-step-by-step.css',
  assetsDirs: ['assets'],
  shadow: true,
})
export class LandingStepByStep {
  @Prop() mainTitle: string = '';
  @Prop() mainSubTitle: string = '';
  @Prop() steps: LandingStep[];

  render() {
    return (
      <div>
        <div class="landing-step-by-step-heading-text lg:text-center">
          {this.mainTitle && <h2 class="text-2xl font-extrabold text-clrs-tabs-text-non-selected-default">{this.mainTitle}</h2>}
          {this.mainSubTitle && <h3 class="text-sm font-medium mt-2">{this.mainSubTitle}</h3>}
        </div>
        <div class="grid lg:grid-cols-3 gap-6 mt-9">
          {this.steps &&
            this.steps.map(({ image, stepTitle, stepSubTitle }) => (
              <div class="lg:text-center lg:items-center grid grid-cols-4 md:grid-cols-8 gap-3 sm:gap-7 md:gap-4 lg:flex lg:flex-col">
                <img src={getAssetPath(`assets/${image}.svg`)} alt={image} class="aspect-square w-full lg:w-1/2 lg:max-w-36 lg:max-h-36 xl:max-w-48 xl:max-h-48" />
                <div class="landing-step-by-step-base-text col-start-2 lg:col-start-1 col-span-full">
                  <div class="text-lg font-bold landing-step-by-step-sub-heading-text">{stepTitle}</div>
                  <div class="text-sm mt-2 lg:mt-6">{stepSubTitle}</div>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}
